import { FC } from "react";
import { Modal } from "@/shared/components/organisms/Modal";
import { t } from "i18next";

type Props = {
  openModalPlanAssignment: boolean;
  handleOpenModalPlanAssignment: () => void;
  onHandleSelect: (value: 0 | 1) => void;
  onClickCreate?: () => void;
  onClickCancel?: () => void;
  onClickSave?: () => void;
};

export const PlaneadoModal: FC<Props> = ({
  openModalPlanAssignment,
  handleOpenModalPlanAssignment,
  onHandleSelect,
  onClickCreate,
  onClickCancel,
  onClickSave,
}) => {
  return (
    <Modal
      open={openModalPlanAssignment}
      Close={handleOpenModalPlanAssignment}
      textButtonClose={t("general.cancel")}
      tittleModal="Asignar o Planificar"
    >
      <div className="grid grids-cols-1 gap-4">
        <div className="col-span-full mt-5">
          <p className="text-sm text-gray-500 px-4">
            ¿Deseas asignar el plan ahora o marcarlo como planeado?
          </p>
        </div>
        <div className="col-span-full px-4 flex justify-end gap-2">
          <button
            className="px-4 py-2 text-white bg-primary rounded"
            onClick={() => {
              onHandleSelect?.(0);
              onClickCreate?.();
              handleOpenModalPlanAssignment?.(false);
            }} // Asignar ahora
          >
            asignar ahora
          </button>
          <button
            className="px-4 py-2 text-white  bg-primary rounded"
            onClick={() => {
              onHandleSelect(1);
              onClickCreate?.();
              handleOpenModalPlanAssignment?.(false);
            }} // Marcar como planeado
          >
            marcar como planeado
          </button>
        </div>
      </div>
    </Modal>
  );
};
